import { getCQActionNameByCode } from "@bitComponents/telcovid/CommonUtils";
import { isNumber } from '@bitComponents/utils/common';
import { PRODUCT_TYPES } from "../../utils/catalog";
import { STRING_KEYS } from "../../localizedStrings/index";
import { CHARACTERISTIC_VALUES, CQ_ACTION_CODES, CQ_POTS } from "../../catalogConstants";
import { add } from "lodash";


export const getGenericProductInfoSection = (info) => {
  const {
    productName,
    productOffering,
    price,
    priceRecurring,
    promotion,
    promotionName,
    shipping,
    payment,
    riskError,
  } = info;

  let productInfo = {};

  if (productName) {
    productInfo["Producto Destino"] = productName;
  }
  if (productOffering) {
    productInfo["ID Producto Destino"] = productOffering;
  }
  if (isNumber(price)) {
    productInfo["Precio producto"] = `${price} €${priceRecurring ? "/mes" : ""}`;
  }
  if (promotion && promotionName) {
    productInfo["Promocion"] = promotion;
    productInfo["NOMBRE PROMO"] = promotionName
  }
  if (shipping.address) {
    productInfo["Dirección de envío"] = shipping.address;
  }
  if (shipping.poshSelected === CQ_POTS.SHIPPING_POT.HOME_SHIPPING_ID) {
    productInfo["Tipo envío"] = 'Envío a domicilio';
  }

  if (payment) {
    if (payment.accountNumber) {
      productInfo["Cuenta bancaria"] = payment.accountNumber;
    }
    if (payment.customerAccountId) {
      productInfo["Id de Cuenta bancaria del cliente"] = payment.customerAccountId;
    }
  }

  if(riskError){
    productInfo["Riesgo"] = "Sí";
    productInfo["Codigo Riesgo"] = riskError;
  }

  return productInfo;
}

export const getR2RToHiredSection = (info) => {
  const {
    productName,
    color,
    productOffering,
    price,
    priceRecurring,
    shipping,
    isPrepurchase,
    pvpr,
    riskCode,
    creditLimit,
  } = info;

  let productInfo = {};

  productInfo["Tipo envío"] = 'Envío a domicilio';

  if (productName) {
    productInfo["INCLUDED_R2R NOMBRE New"] = productName;
  }
  if (color) {
    productInfo["Color"] = color;
  }
  if (productOffering) {
    productInfo["INCLUDED_R2R IDPO New"] = productOffering;
  }
  if (isNumber(price)) {
    productInfo["INCLUDED_R2R PRECIO FINAL New"] = `${price} €${priceRecurring ? "/mes" : ""}`;
  }
  if (shipping.address) {
    productInfo["Dirección de envío"] = shipping.address;
  }
  if (shipping.poshSelected === CQ_POTS.SHIPPING_POT.HOME_SHIPPING_ID) {
    productInfo["Tipo envío"] = 'Envío a domicilio';
  }
  if (isPrepurchase) {
    productInfo["Precompra"] = 'si';
  } else {
    productInfo["Precompra"] = 'no';
  }
  if (isNumber(pvpr)) {
    productInfo["PVPR TOTAL SIN IMPUESTOS"] = pvpr;
  } else {
    productInfo["PVPR TOTAL SIN IMPUESTOS"] = 'Desconocido';
  }
  if (riskCode) {
    productInfo["RESULTADO VALORACION RIESGO"] = riskCode;
  } else {
    productInfo["RESULTADO VALORACION RIESGO"] = 'Desconocido';
  }
  if (isNumber(creditLimit)) {
    productInfo["CREDITO TOTAL DISPONIBLE"] = creditLimit;
  } else {
    productInfo["CREDITO TOTAL DISPONIBLE"] = 'Desconocido';
  }

  return productInfo;
}

export const getR2RCancelSection = (info) => {
  let additionalInfo = {};
  if (info) {
    additionalInfo["Descripción del Producto"] = 'r2rRenewal';
    if (info.productOfferingId) {
      additionalInfo["ID PRODUCT OFFERING a cancelar"] = info.productOfferingId;
    }
    if (info.productName) {
      additionalInfo["NOMBRE TERMINAL a cancelar"] = info.productName;
    }
    if (info.cancellationFee) {
      additionalInfo["COSTE DE CANCELACIÓN ANTICIPADA"] = info.cancellationFee;
    }
    if (info.hasMobileInsurance === true) {
      additionalInfo["TIENE SEGURO MOVIL"] = 'SI';
    } else if (info.hasMobileInsurance === false) {
      additionalInfo["TIENE SEGURO MOVIL"] = 'NO';
    }
  }
  return additionalInfo;
};



